export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    close: '关闭',
    loading: '加载中...',
    noData: '暂无数据',
    operation: '操作',
    status: '状态',
    sort: '排序',
    createTime: '创建时间',
    updateTime: '更新时间',
    actions: '操作',
    enable: '启用',
    disable: '禁用',
    active: '活跃',
    inactive: '未激活'
  },
  
  // 导航菜单
  nav: {
    dashboard: '仪表盘',
    products: '产品管理',
    productList: '产品列表',
    categories: '分类管理',
    company: '公司信息',
    cases: '客户案例',
    caseStudies: '案例研究',
    faq: '常见问题',
    advantages: '核心优势',
    process: '服务流程',
    inquiries: '咨询管理',
    siteConfig: '网站配置',
    translations: '翻译管理'
  },
  
  // 登录
  login: {
    title: 'CMS 管理系统',
    username: '用户名',
    password: '密码',
    loginBtn: '登录',
    logout: '退出登录',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    tips: '提示',
    success: '登录成功',
    error: '登录失败，请检查用户名和密码'
  },
  
  // 仪表盘
  dashboard: {
    title: '欢迎使用 CMS 管理系统',
    subtitle: '企业官网内容管理系统',
    totalProducts: '产品总数',
    totalCases: '案例总数',
    totalInquiries: '咨询总数',
    systemStatus: '系统状态',
    quickAccess: '快捷入口',
    recentActivity: '最近活动'
  },
  
  // 产品管理
  product: {
    listTitle: '产品列表',
    createTitle: '新增产品',
    editTitle: '编辑产品',
    productId: '产品 ID',
    name: '产品名称',
    shortName: '简称',
    category: '所属分类',
    description: '产品描述',
    price: '价格',
    priceUnit: '价格单位',
    imageUrl: '主图',
    badge: '标签',
    demoUrl: '演示地址',
    features: '功能特性',
    highlights: '产品亮点',
    techStack: '技术栈',
    screenshots: '截图展示',
    status: '状态',
    allCategories: '全部分类',
    addFeature: '添加功能',
    addHighlight: '添加亮点',
    addTech: '添加技术',
    addScreenshot: '添加截图',
    uploadImage: '上传图片',
    selectCategory: '选择分类'
  },
  
  // 分类管理
  category: {
    categoryId: '分类 ID',
    name: '分类名称',
    icon: '图标',
    sortOrder: '排序',
    status: '状态'
  },
  
  // 公司信息
  company: {
    name: '公司名称',
    englishName: '英文名称',
    slogan: '口号',
    description: '公司简介',
    founded: '成立时间',
    employees: '员工人数',
    clients: '客户数量',
    projects: '项目数量',
    phone: '联系电话',
    email: '联系邮箱',
    address: '公司地址',
    workHours: '工作时间',
    wechatLink: '微信链接',
    weiboLink: '微博链接',
    linkedinLink: '领英链接'
  },
  
  // 客户案例
  clientCase: {
    name: '客户名称',
    industry: '所属行业',
    systemType: '系统类型',
    logoIcon: 'Logo 图标',
    description: '案例描述',
    results: '成果展示',
    sortOrder: '排序',
    addResult: '添加成果'
  },
  
  // 案例研究
  caseStudy: {
    caseId: '案例 ID',
    title: '案例标题',
    subtitle: '副标题',
    clientName: '客户名称',
    industry: '行业',
    coverImage: '封面图',
    images: '案例图片',
    challenge: '面临挑战',
    solution: '解决方案',
    results: '实施成果',
    resultTags: '成果标签',
    addImage: '添加图片',
    addTag: '添加标签'
  },
  
  // FAQ
  faq: {
    question: '问题',
    answer: '答案',
    sortOrder: '排序',
    addQuestion: '添加问题'
  },
  
  // 核心优势
  advantage: {
    icon: '图标',
    title: '优势标题',
    description: '优势描述',
    sortOrder: '排序'
  },
  
  // 服务流程
  process: {
    stepNumber: '步骤编号',
    title: '步骤标题',
    description: '步骤描述',
    icon: '图标'
  },
  
  // 网站配置
  siteConfig: {
    siteName: '网站名称',
    siteTitle: '网站标题',
    keywords: '关键词',
    description: '网站描述',
    copyright: '版权信息',
    icpLicense: 'ICP 备案号',
    publicSecurityLicense: '公安备案号',
    seoConfig: 'SEO 配置',
    basicConfig: '基础配置',
    contactConfig: '联系配置',
    socialLinks: '社交链接'
  },
  
  // 咨询管理
  inquiry: {
    name: '姓名',
    phone: '电话',
    email: '邮箱',
    company: '公司',
    content: '咨询内容',
    status: '状态',
    handleStatus: '处理状态',
    handled: '已处理',
    unhandled: '未处理',
    contactTime: '联系时间',
    remark: '备注'
  },
  
  // 提示信息
  message: {
    confirmDelete: '确定要删除吗？',
    deleteSuccess: '删除成功',
    saveSuccess: '保存成功',
    updateSuccess: '更新成功',
    createSuccess: '创建成功',
    operationFailed: '操作失败',
    dataNotExist: '数据不存在',
    pleaseSelect: '请选择',
    inputRequired: '请输入',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    fileSizeLimit: '文件大小不能超过',
    fileTypeLimit: '只支持图片格式',
    networkError: '网络错误，请稍后重试'
  },
  
  // 验证规则
  validation: {
    required: '{field}不能为空',
    minLength: '{field}长度不能小于{min}个字符',
    maxLength: '{field}长度不能大于{max}个字符',
    email: '请输入正确的邮箱地址',
    phone: '请输入正确的手机号码',
    url: '请输入正确的 URL 地址',
    number: '请输入数字',
    pattern: '格式不正确'
  },
  
  // 语言切换
  language: {
    switcher: '语言',
    zhCN: '简体中文',
    zhTW: '繁體中文',
    en: 'English',
    ru: 'Русский'
  }
}
